import React, { Component } from "react";
import { Button } from "react-bootstrap";
import { mockAxios } from "../../../../theme";
import axios from 'axios';
import SimpleReactValidator from 'simple-react-validator';

var CryptoJS = require("crypto-js");
let key = process.env.REACT_APP_CRYPTO_KEY

class CreateUser extends Component {

  constructor(props) {
    super(props);
    this.state = {
      "firstname": "", "lastname": "", "phone": "",
      "emailid": "", "password": "", "usertype": "", "cPassword": "", //passLength : false,
      "firstNameRequired": false, "lastNameRequired": false, "phoneRequired": false,
      "emailIdRequired": false, "passwordRequired": false, throwError: false,
      // errors: {
      //   firstName: '',
      //   emailId: '',
      //   password: '',
      // },
    };
    this.firstNameRef = React.createRef();
    this.lastNameRef = React.createRef();
    this.phoneRef = React.createRef();
    this.emailIdRef = React.createRef();
    this.passwordRef = React.createRef();
    this.handleFormFields = this.handleFormFields.bind(this);
    this.submitHandler = this.submitHandler.bind(this);
    this.validForm = this.validForm.bind(this);
    this.leaveHandle = this.leaveHandle.bind(this);

    this.validator = new SimpleReactValidator({ autoForceUpdate: this, className: 'text-danger' });

  }

  componentDidMount() {
    mockAxios(axios).restore();
  }

  handleFormFields = (event) => {
    this.validator.showMessageFor(event.target.name)
    switch (event.target.id) {
      case "ufirstname":
        this.setState({ "firstname": event.target.value });
        break;
      case "ulastname":
        this.setState({ "lastname": event.target.value });
        break;
      case "uphone":
        this.setState({ throwError: false, "phone": event.target.value });
        break;
      case "uemailid":
        this.setState({ throwError: false, "emailid": event.target.value });
        break;
      case "upassword":
        this.setState({ "password": event.target.value });
        break;
      case "ucpass":
        this.setState({ "cPassword": event.target.value });
        break;
      case "uusertype":
        this.setState({ "usertype": event.target.value });
        break;
      default:
        break;
    }
  };

  validForm() {
    const { firstname, lastname, phone, emailid, password } = this.state;
    let validFormFlag = false;
    if (firstname === '') {
      this.setState({ firstNameRequired: true });
      return validFormFlag;
    }
    else if (lastname === '') {
      this.setState({ lastNameRequired: true });
      return validFormFlag;
    }
    else if (phone === '') {
      this.setState({ phoneRequired: true });
      return validFormFlag;
    }
    else if (emailid === '') {
      this.setState({ emailIDRequired: true });
      return validFormFlag;
    }
    // else if (password === '') {
    //   this.setState({ passwordRequired: true });
    //   return validFormFlag;
    // }
    else {
      return true;
    }
  }

  submitHandler = () => {
    if (this.validator.allValid()) {
      let postUserData = {
        userFirstName: this.state.firstname, userLastName: this.state.lastname, userPhoneNumber: this.state.phone,
        userEmail: this.state.emailid, userPassword: this.state.password, userType: this.state.usertype
      };
      postUserData = CryptoJS.AES.encrypt(JSON.stringify(postUserData),key).toString()
      fetch(process.env.REACT_APP_NODE_ENV + '/api/users/createUser', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': process.env.REACT_APP_API_AUTH_TYPE + btoa(process.env.REACT_APP_API_AUTH_USERNAME + ":" + process.env.REACT_APP_API_AUTH_PASSWORD),
        },
        body: JSON.stringify({ data: postUserData })
      }).then(response => {
        if (response.ok) { this.props.history.push("/user/user-list"); }
        else if (response.status === 400) {
          this.setState({ throwError: true })
        }
      })
        .catch(err => console.log(err))
    } else {
      this.validator.showMessages();
      this.forceUpdate();
    }

  }

  leaveHandle = (event) => {
    event.preventDefault();
    this.validator.showMessageFor(event.target.name)
    const { id, value } = event.target;
    let errors = this.state.errors;

    switch (id) {
      // case 'upassword':
      //   errors.password =
      //     value.length < 8
      //       ? 'Password must be 8 characters long!'
      //       : '';
      //       if(value.length < 8){
      //         this.setState({ passLength : true});
      //       }
      //       else{
      //         this.setState({ passLength : false});
      //       }
      //   break;
      default:
        break;
    }

    this.setState({ errors, [id]: value }, () => {
    })
  }

  render() {

    let errorMessage = "";

    if (this.state.throwError) {
      errorMessage = (<span style={{ color: "red" }}>Either Email/Phone Number Already Exist</span>)
    }

    return (
      <>
        <form>
          <div className="kt-heading kt-heading--md">User Details</div>
          <div className="kt-form__section kt-form__section--first">
            <div className="kt-wizard-v1__form">
              <div className="row">
                <div className="col-xs-2">
                  <div className="form-group">
                    <label>First Name</label>
                    <input type="text" className="form-control" ref={this.firstNameRef} name="first name" id="ufirstname" placeholder="First Name" value={this.state.firstname} onChange={this.handleFormFields} onBlur={this.leaveHandle} />

                    {
                      this.validator.message('first name', this.state.firstname, 'required|alpha')
                    }
                    {
                      this.state.firstNameRequired &&
                      <span className="form-text text-muted">Please enter your First Name.</span>
                    }

                  </div></div> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                <div className="col-xs-2">
                  <div className="form-group">
                    <label>Last Name</label>
                    <input type="text" className="form-control" pattern="[A-Za-z]{3}" required name="last name" id="ulastname" placeholder="Last Name" value={this.state.lastname} onChange={this.handleFormFields} />
                    {
                      this.validator.message('last name', this.state.lastname, 'required|alpha')
                    }
                    {
                      this.state.lastNameRequired &&
                      <span className="form-text text-muted">Please enter your Last Name.</span>
                    }

                  </div></div></div>
              <div className="row">
                <div className="col-xs-2">
                  <div className="form-group">
                    <label>Phone Number</label>
                    <input className="form-control" required name="phone" id="uphone" placeholder="Phone Number" value={this.state.phone} onChange={this.handleFormFields} />
                    {
                      this.validator.message('Phone Number', this.state.phone, 'required|phone|max:13')
                      //this.validator.message('phone', this.state.phone, 'required|phone')
                    }
                    {
                      this.state.phoneRequired &&
                      <span className="form-text text-muted">Please enter your Phone Number.</span>
                    }

                  </div></div>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  <div className="col-xs-2">
                  <div className="form-group">
                    <label>E-mail</label>
                    <input type="email" className="form-control" required name="email" id="uemailid" placeholder="E-mail" value={this.state.emailid} onChange={this.handleFormFields} />
                    {
                      this.validator.message('E-mail', this.state.emailid, 'required|email')
                    }
                    {
                      this.state.emailIdRequired &&
                      <span className="form-text text-muted">Please enter your E-mail .</span>
                    }

                  </div>
                </div></div>
              <div className="row">
                <div className="col-xs-2">
                  <div className="form-group">
                    <label>Password</label>
                    <input type="password" className="form-control" ref={this.passwordRef} required name="nupassword" id="upassword" placeholder="Enter Your Password" value={this.state.password} onChange={this.handleFormFields} />
                    {
                      this.validator.message('nupassword', this.state.password, 'required|max:20|min:8')
                    }
                    {/* {
                      this.state.passwordRequired &&
                      <span className="form-text text-muted">Please enter your password.</span>
                    } */}
                    {/* {
                      this.state.passLength && 
                      <span className="form-text text-muted"><div style={{color:'Red'}}>Password Must Be Minimum 8 characters</div></span>
                    } */}
                  </div>
                </div>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  <div className="col-xs-2">
                  <div className="form-group">
                    <label>Confirm Password</label>
                    <input type="password" className="form-control" required name="Confirm Password" id="ucpass" placeholder="Confirm Your Password" value={this.state.cPassword} onChange={this.handleFormFields}
                    />
                    {this.validator.message('Confirm Password', this.state.cPassword, `required|in:${this.state.password}`, { messages: { in: 'Passwords need to match!' } })}

                    {/* <span className="form-text text-muted">Please confirm your password.</span> */}
                  </div>
                </div></div>

              <div className="row">
                <div className="col-xs-2">
                  {/*  <div className="form-group">
                      <label>Address</label>
                      <input type="text" className="form-control" required name="nuAddress" id="uAddress" placeholder="Address"
                      />
                      <span className="form-text text-muted">Please enter your Address.</span>
                    </div> */}</div>
                <div className="col-xs-2">
                  <div className="form-group">
                    <label>User Type</label>
                    <select name="nuusertype" className="form-control" id="uusertype" value={this.state.usertype} onChange={this.handleFormFields}>
                      <option value="">Select User Type</option>
                      <option value="Administrator">Administrator</option>
                      <option value="Support User">Support User</option>
                      <option value="CRE">CRE</option>
                      <option value="Logistics">Logistics</option>
                      <option value="Project Engineer">Project Engineer</option>
                      <option value="Marketing">Marketing</option>
                      <option value="Accounts">Accounts</option>
                    </select>
                  </div></div>
              </div>
              <div>
                {errorMessage}
              </div>

              <div>
                <Button variant="outline-success" className="btn-sm btn-bold float-left" style={{ marginTop: "10px", marginLeft: "5px" }} onClick={this.submitHandler} >Submit</Button>
              </div>
            </div>
          </div>
        </form>
      </>
    );
  }
}

export default CreateUser;


